import {
    Box,
    Dialog,
    Slide,
    Divider,
} from "@mui/material";
import { useState, forwardRef } from "react";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function ReviewBlogHelp() {
    const [open, setOpen] = useState(false);

    return (
        <Box>
            <Dialog
                fullScreen
                open={open}
                onClose={() => setOpen(false)}
                TransitionComponent={Transition}
                >
                <Box
                    sx={{
                        width: '90%',
                        textAlign: 'left',
                        padding: '30px 0 10px 10px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                    }}>
                    <img src='/img/back_button_black.png' onClick={() => setOpen(false)} />
                    <Box
                        sx={{
                            margin: '16px 0 0 10px',
                            fontSize: '22px',
                            fontWeight: 'bold'
                        }}>
                        블로그 예시 보러가기
                    </Box>
                </Box>
                <Divider />
                <Box
                    width='100%'
                    textAlign='center'>
                    <img src='/img/blog_example02.jpg' width='80%' />
                </Box>
            </Dialog>
            <Box
                sx={{
                    fontSize: '12px',
                    color: '#1976d2',
                    width: 'fit-content'
                }}
                onClick={() => setOpen(true)}
                >
                블로그 예시 보러가기
            </Box>
        </Box>
    )
}

export default ReviewBlogHelp;